import $ from 'jquery';

$(function() {
  if($('#addGuestRSVPFormModal').length > 0) {
    var AcceptRSVPMemberOnlyBtn = $('#cwm-AcceptRSVPMemberOnly');
    var AttendeeFORMSubmitBtn = $('#attendeeFORMSubmitBtn');
    var prevBtn = $('#add-guest__prevBtn');
    var nextBtn = $('.add-guest__nextBtn');
    var addGuestFormModal = $('#addGuestRSVPFormModal');
    var guestNotAttendingLink = $('.add-guest__not-attendee-link');
    var nextRemoveDisableBtn = $('#attendeeFORMSubmitBtnnext');
    var deputyMemberCheckbox = $('.add-guest__checkbox--input');
    var deputyMemberContainer = $(".Deputy-member-container");
    deputyMemberContainer.hide(); // Hidden deputy field by default
    var cwm_currentTab = 0; // Current tab is set to be the first tab (0)
    cwm_showTab(cwm_currentTab); // Display the current tab

    prevBtn.click(function(){
        nextPrev(-1);
    });
    nextBtn.click(function(){
        nextPrev(1)
    });

    function cwm_showTab(n) {
      // This function will display the specified tab of the form...
      var cwm_alltabs = document.getElementsByClassName("add-guest_tab");
      cwm_alltabs[n].style.display = "block";
      //... and fix the Previous/Next buttons:
      if (n == 0) {
      document.querySelector('#add-guest__prevBtn').disabled = true;
      } else {
        document.querySelector('#add-guest__prevBtn').disabled = false;
      }
      if (n == (cwm_alltabs.length - 1)) {
        document.querySelector('.add-guest__nextBtn').disabled = true;
        $('#attendeeFORMSubmitBtnnext').hide();
        $('#attendeeFORMSubmitBtn').show();
      } else {
         document.querySelector('.add-guest__nextBtn').disabled = false;
        $('#attendeeFORMSubmitBtn').hide();
        $('#attendeeFORMSubmitBtnnext').show();
      }
        document.getElementById("totalP").innerHTML =  cwm_alltabs.length;
      //... and run a function that will display the correct step indicator:
      fixStepIndicator(n)
    }
    function validateForm() {
        // This function deals with validation of the form fields
        var cwm_alltabs, cwm_Input, i, valid = true;
        cwm_alltabs = document.getElementsByClassName("add-guest_tab");
        
        cwm_Input = cwm_alltabs[cwm_currentTab].querySelector("input.add-guest__member-name");
        // A loop that checks every input field in the current tab:
        for (i = 0; i < cwm_alltabs.length; i++) {
           // If a field is empty...
          if (cwm_Input.value == "") {
            // add an "invalid" class to the field:
            cwm_Input.className += " invalid";
            // and set the current valid status to false
            valid = false;
          } else {
            cwm_Input.classList.remove("invalid");
          }
          //removing disabled form validation 
          if(cwm_Input.disabled && cwm_Input.value == "") {
            cwm_Input.classList.remove("invalid");
            valid = true;
          }
        }
        return valid; // return the valid status
    }

    function fixStepIndicator(n) {
        document.getElementById("currentP").innerHTML = n + 1;
    }

    function nextPrev(n) {
      // This function will figure out which tab to display
      var cwm_alltabs = document.getElementsByClassName("add-guest_tab");
      // Exit the function if any field in the current tab is invalid:
      if (n == 1 && !validateForm()) return false;
      
      cwm_alltabs[cwm_currentTab].style.display = "none";
      // Increase or decrease the current tab by 1:
      cwm_currentTab = cwm_currentTab + n;
      // if you have reached the end of the form...
      if (cwm_currentTab >= cwm_alltabs.length) {
        // ... the form gets submitted:
        ajaxCall();       
        return false;
      }
      // Otherwise, display the correct tab:
      cwm_showTab(cwm_currentTab);
    };

    AcceptRSVPMemberOnlyBtn.on( "click", function() { 
      ajaxCall();
    });

    AttendeeFORMSubmitBtn.on( "click", function() { 
      lastTabvalid(); 
      $('.add-guest_tab:last-child').css('display','block');
    });

    function lastTabvalid(n) {
      if (n == 1 && !validateForm()) return false;
    }
    
    function ajaxCall() {       
      var serialform = [];   
      var guestTab = document.getElementsByClassName("add-guest_tab");
      var whelechairrequiredLength = $(".iswheelchair_required").length;
      
          for (var i = 0; i < guestTab.length; i++) {
            var input_MembersID = "id_" + i;
            var input_AttendeeTypeID = "AttendeeType_" + i ;
            var input_MembersNameID = "add-guest__member-name_" + i;
            var input_DeputyMemberNameID = "add-Deputy__member-name_" + i;
            var textarea_DietaryReqID="add-guest__dietary-req_" + i;
            var textarea_commentsID= "add-guest__other-info_" + i;
            var textarea_AttendeeGolfID = "add-guest__golf-handicap_" + i ;
            var radiocheckedName = "input:radio" + "[name = addGuestWheelchairRadios_" + i +']:checked ';
            var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i +']';
           
            var input_ID =  $("#" + input_MembersID);
            var input_AttendeeType =  $("#" + input_AttendeeTypeID);
            var input_MembersName =  $("#" + input_MembersNameID);
            var input_DeputyMemberName = $("#" + input_DeputyMemberNameID);
            var textarea_DietaryReq=  $("#" + textarea_DietaryReqID); 
            var textarea_comments= $("#" + textarea_commentsID); 
            var textarea_AttendeeGolf =  $("#" + textarea_AttendeeGolfID);  
            var radiochecked =  $(radiocheckedName); 
            var radioNotattendeeValue = $(radioNotattendeeName);
           if(whelechairrequiredLength > 0 ){ 
            var myArr = {
              Id:input_ID.val(),
              AttendeeType:input_AttendeeType.val(),
              IsAttending:radioNotattendeeValue.val(),
              DeputyAttendeeName:input_DeputyMemberName.val(),
              Name:input_MembersName.val(),
              Handicap:textarea_AttendeeGolf.val(),
              DietaryRequirements:textarea_DietaryReq.val(),
              WheelchairRequired: radiochecked.val(),
              Comments:textarea_comments.val(),
            };
           } else { 
            var myArr = {
              Id:input_ID.val(),
              AttendeeType:input_AttendeeType.val(),
              IsAttending:radioNotattendeeValue.val(),
              DeputyAttendeeName:input_DeputyMemberName.val(),
              Name:input_MembersName.val(),
              Handicap:textarea_AttendeeGolf.val(),
              DietaryRequirements:textarea_DietaryReq.val(),
              WheelchairRequired: false,
              Comments:textarea_comments.val(),
            }; 
          }
          serialform.push(myArr); 
          }
          var eventData = {
            SitecoreEventId: $("#SitecoreEventId").val(),
            Attendees: serialform,
          }
        $('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
      $.ajax({
          url:'/api/sitecore/CWMEvents/ConnectionEventAcceptRSVP',
          type: 'POST',
          data: JSON.stringify(eventData),
          processData: false, // tell jQuery not to process the data
          contentType: 'application/json',
          success: function (response) {
              console.log(response.success);
                window.location.reload(); 
              addGuestFormModal.modal('hide');              
          },
          // Error handling
          error: function (response) {
              $('html').css({ 'overflow-y': "scroll" });
              $("#cwm-overlay").hide();
              console.log(response.error);
              addGuestFormModal.modal('hide');
          }
      });
    }
  guestNotAttendingLink.click(function() {
    addImediateClassToTab();
    var guestTab = document.getElementsByClassName("add-guest_tab");
    var cwm_Input = guestTab[cwm_currentTab].querySelector("input.add-guest__member-name");

    for (var i = 0; i < guestTab.length; i++) {
      if (cwm_Input.value != "" ) {
        cwm_Input.value = "";
      }
      var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i +']';
      var radioNotattendeeValue = $(radioNotattendeeName);
      $('.guest-not-attending').find(radioNotattendeeValue).attr("value", 'false'); 
    }
    $('.guest-not-attending *').attr('disabled', true);   
    nextBtn.attr('disabled', false); 
    AttendeeFORMSubmitBtn.attr('disabled', false);   
  });

  function addImediateClassToTab() {
    var guestTab = document.getElementsByClassName("add-guest_tab");
    guestTab[cwm_currentTab].classList.add("guest-not-attending");
    
  };

  // Deputy member checkbox click function
  deputyMemberCheckbox.click(function(){
    var i = 0;
    var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i +']';
    var radioNotattendeeValue = $(radioNotattendeeName);
    if($(this).is(":checked")) {
      deputyMemberContainer.show();
      radioNotattendeeValue.attr("value", 'false');
    } else {
      deputyMemberContainer.hide();
      radioNotattendeeValue.attr("value", 'true');
    }
  });
  }
});



// WEBPACK FOOTER //
// ./components/cwm-connections-attendee-details/scripts/cwm-connections-attendee-details.js